<div id="manage-mfa" class="mx-auto flex flex-column align-content-center align-items-center gap-2">
  <h2 class="mb-2" i18n>Manage your MFA (Multi-factor Authentication) Options</h2>
  <p class="my-0 py-0" i18n>Please click on an MFA option to use it as default</p>


  <div id="email" role="button" class="mfa-option w-30rem" tabindex="1" (click)="manageEmail()" (keydown.space)="manageEmail()" aria-labelledby="email-label">
    <p hidden id="email-label">Receive 2FA Codes via your Email inbox{{ defaultMfa === 'email' ? ', current default' : '' }}</p>
    <p-card>
      <div class="flex flex-row">
        <i class="pi pi-inbox my-auto"></i>
        <div class="flex-column mx-5">
          <h3 i18n>Email</h3>
          <p i18n>Receive 2FA Codes via your Email inbox</p>
        </div>
      </div>
      @if (defaultMfa === 'email') {
        <div class="flex flex-row-reverse">
          <i class="pi pi-check-circle"></i>
        </div>
      }
    </p-card>
  </div>

<!--  <div id="sms" role="button" class="mfa-option w-30rem" tabindex="1" (click)="manageSms()" (keydown.space)="manageSms()" aria-labelledby="sms-label">-->
<!--    <p hidden id="sms-label">Receive 2FA Codes via SMS{{ defaultMfa === 'sms' ? ', current default' : ''}}</p>-->
<!--    <p-card>-->
<!--      <div class="flex flex-row">-->
<!--        <i class="pi pi-mobile my-auto"></i>-->
<!--        <div class="flex-column mx-5">-->
<!--          <h3 i18n>SMS</h3>-->
<!--          <p i18n>Receive 2FA Codes via SMS</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      @if (defaultMfa === 'sms') {-->
<!--        <div class="flex flex-row-reverse">-->
<!--          <i class="pi pi-check-circle"></i>-->
<!--        </div>-->
<!--      }-->
<!--    </p-card>-->
<!--  </div>-->

  <div id="totp" role="button" class="mfa-option w-30rem" tabindex="1" (click)="manageApp()" (keydown.space)="manageApp()" aria-labelledby="totp-label">
    <p hidden id="totp-label">Receive 2FA Codes via an authenticator app of your choice{{ defaultMfa === 'totp' ? ', current default' : ''}}</p>
    <p-card>
      <div class="flex flex-row">
        <i class="pi pi-qrcode my-auto"></i>
        <div class="flex-column mx-5">
          <h3 i18n>Authenticator App</h3>
          <p i18n>Receive 2FA Codes via an authenticator app of your choice</p>
        </div>
      </div>
      @if (defaultMfa === 'totp') {
        <div class="flex flex-row-reverse">
          <i class="pi pi-check-circle"></i>
        </div>
      }
    </p-card>
  </div>

  @if (error) {
    <div class="mx-auto">
      <p-message severity="error" i18n>There was an error when setting your preference. Please try again later</p-message>
    </div>
  } @else if (defaultSet) {
    <div class="mx-auto">
      <p-message severity="success" i18n>Default MFA Option set! Redirecting you to the homepage.</p-message>
    </div>
  }
</div>
